import React from 'react'
import SwitchRouter from 'components/SwitchRouter'
import { Route } from 'react-router-dom'
import UploadNotaFiscal from './upload-nf/UploadNotaFiscal'
import ColetaDados from './coleta-dados/ColetaDados'

export default function CartaoRoutes() {
    return (
        <SwitchRouter>
            <Route exact path='/recebiveis/cartao/upload-nf' component={UploadNotaFiscal} />
            <Route exact path='/recebiveis/cartao/coleta-de-dados' component={ColetaDados} />
        </SwitchRouter>
    )
}
